import React from 'react';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

const padding = '8px 60px';
const base: CSSProperties =  {
    all: 'unset',
    padding,
    margin: '0 5px',
    borderRadius: 4,
    fontWeight: 'bold',
    fontSize: 14,
    paddingRight: "50px",
    paddingLeft: "50px",
    marginRight: "20px",
    textTransform: 'capitalize',
    letterSpacing: 0
}

const styles = {
    save: {
        ...base,
        backgroundColor: '#0079E4',
        color: '#fff',
        cursor:"pointer"
    },
    cancel: {
        ...base,
        backgroundColor: '#F1F1F5',
        color: '#0079E4',
        cursor:"pointer"

    }
};

export interface SaveAndCancelProps {
    saveHandler: ((() => void) | undefined );
    cancelHandler: () => void;
    cancelText?: string | undefined;
    update?: boolean;
}

export default (props: SaveAndCancelProps) => {

    return (
        <div>
            {
                props.saveHandler !== undefined && <button type="submit" onClick={props.saveHandler} style={styles.save}> { props.update ? 'Update' : 'Save' }</button>
            }
            <button onClick={props.cancelHandler} style={styles.cancel}>{props.cancelText !== undefined ? props.cancelText : 'Cancel'}</button>
        </div>
    );
}